export function getAuth0Locale(language: string): string {
  if (!language || language === 'en') {
    return language;
  }
  if (language === 'pt') {
    // auth0 only supports pt-PT or pt-BR but we don't distinguish
    return 'pt-PT';
  }
  return `${language} en`;
}
